module.exports = __webpack_public_path__ + "img/img_material.3d286715.png";